<template>
  <div class="input-select d-block" v-on-clickaway="closeSelect">
    <label
      v-if="label"
      @click="closeSelect">{{ $t(label) }} <span v-if="rules.required" class="warning-color">*</span></label>
    <div
      :class="{required: shouldShowError}"
      @click="openListOnClick"
      class="input-like"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue !== ''" class="cut-text">{{ cmpTextValue }}</span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
    <div v-show="isListOpened" class="options-list">
      <input
        ref="searchField"
        class="search"
        v-model="search"
        @keydown="searchIt"
        :placeholder="$t('Search...')" />
      <hr v-if="multiSelect" />
      <div class="row-no-gutters multiselect-global-controls c-float" v-if="multiSelect">
        <div class="col-xs-6"><div class="button light d-inline-block" @click="selectAll"><span class="button-text">{{ $t('select_all')}}</span></div></div>
        <div class="col-xs-6"><div class="button light d-inline-block" @click="selectNone"><span class="button-text">{{ $t('unselect_all')}}</span></div></div>
      </div>
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(option, index) in filteredList"
          :key="`option-${index}`"
          :ref="`${randomSelectId}-${index}-opt`"
          :class="{active : Object.values(preselected).includes(option.value)}"
          class="flex"
        >
          <Checkbox
            v-if="multiSelect"
            :key="`checkbox-select-${index}`"
            :ref="`checkbox-select-${index}`"
            :value="preselected.indexOf(option.value) > -1"
            class="m-r-10"
            @change="onChange($event, option)" />
          <span @click="changeValue(index, option)" style="flex: 1">{{ `${option.text}` }}</span>
          <input :value="option.value" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";
import {mapGetters} from "vuex";

export default {
  name: 'shippingAgentSelect',
  mixins: [rules],
  components: {
    Checkbox,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    multiSelect: {
      type: Boolean,
      default: false,
    },
    preselected: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isShortened: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      multiSelectArray: [],
    };
  },
  computed: {
    filteredList() {
      return this.get_company_available_shipping_agents_select.filter(option => {
        const term = `${option.text}`;
        return term.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.multiSelect){
        const arrayResult = [];
        this.get_company_available_shipping_agents_select.forEach((item) => {
          if(this.preselected.indexOf(item.value) > -1){
            arrayResult.push(item.text)
          }
        });
        return arrayResult.join(', ');
      }
      if(this.value === null || this.value === undefined) return '';
      if( (this.value !== '') && (this.filteredList.length > 0) ) {
        this.filteredList.filter((opt, index) => {
          if(opt.value == this.value) this.indexItem = index;
        });
      }
        return this.value !== '' ? this.get_company_available_shipping_agents_select.filter(opt => opt.value == this.value)[0].text : '';
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    ...mapGetters([
      'get_company_available_shipping_agents_select'
    ])
  },
  async created() {
    await this.$store.dispatch('GET_COMPANY_AVAILABLE_SHIPPING_AGENTS');
  },
  methods: {
    selectAll() {
      this.filteredList.forEach(item => {
        this.onChange(true, item)
      })
    },
    selectNone() {
      this.filteredList.forEach((item, index) => {
        this.onChange(false, item)
      })
    },
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        this.search = event.target.value;
      }
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.filteredList.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(index, option) {
      if(!this.multiSelect){
        this.indexItem = index;
        this.isListOpened = false;
        this.openedOnClick = false;
        this.$emit('change', option.value);
        this.$emit('input', option.value);
        this.search = '';
      }else {
        this.onChange(!this.$refs[`checkbox-select-${index}`][0].value, option)
      }
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    onChange(val, item) {
      const newArray = Array.isArray(this.preselected) ? [...this.preselected] : [];
      if (!val) {
        const idx = newArray.indexOf(item.value);
        if (idx > -1) {
          newArray.splice(idx, 1);
        }
      } else {
        if (newArray.indexOf(item.value) < 0) {
          newArray.push(item.value);
        }
      }

      this.$emit('change', newArray);
      this.$emit('input', newArray);
    },
  },
}
</script>
